import { Link } from 'react-router-dom';

import {
  Box,
} from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledLocalSettingContainer = styled(Box)`
  &&& {
    align-items: flex-start;
    justify-content: space-between;
    overflow-x: auto;
    padding: var(--cl-space-5) var(--cl-space-6);
    gap: var(--cl-space-4);
    flex-direction: column;
  }
`;

export const StyledLink = styled(Link)`
  &&& {
    color: var(--cl-text-link);
    font-size: var(--cl-font-size-2);
    font-weight: var(--cl-font-weight-regular);
    text-transform: initial;
    line-height: var(--cl-line-height-4);
  }
`;

export const ColumnBox = styled(Box)`
  &&& {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--cl-space-2);
  }
`;

